import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Heading-1-Paragraph-Styles-Heading--Streamline-Flex"
    >
        <desc>
            {
                'Heading 1 Paragraph Styles Heading Streamline Icon: https://streamlinehq.com'
            }
        </desc>
        <g id="heading-1-paragraph-styles-heading">
            <path
                id="Vector 1"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 12.501V1.50098m7 0V12.501m-7 -5.95836c2.35186 -0.28937 4.64814 -0.28937 7 0"
                strokeWidth={1}
            />
            <g id="Group 6075">
                <g id="Group 6076">
                    <path
                        id="Vector 2"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m11.9634 12.501 0 -4.31741 -1.5365 0"
                        strokeWidth={1}
                    />
                </g>
                <path
                    id="Vector 1_2"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m13.5 12.501 -1.5364 0 -1.5365 0"
                    strokeWidth={1}
                />
            </g>
        </g>
    </svg>,
);
